/* @generated */
// prettier-ignore
if (Intl.RelativeTimeFormat && typeof Intl.RelativeTimeFormat.__addLocaleData === 'function') {
  Intl.RelativeTimeFormat.__addLocaleData({
  "data": {
    "day": {
      "-1": "tegnap",
      "-2": "tegnapelőtt",
      "0": "ma",
      "1": "holnap",
      "2": "holnapután",
      "future": {
        "one": "{0} nap múlva",
        "other": "{0} nap múlva"
      },
      "past": {
        "one": "{0} nappal ezelőtt",
        "other": "{0} nappal ezelőtt"
      }
    },
    "day-narrow": {
      "-1": "tegnap",
      "-2": "tegnapelőtt",
      "0": "ma",
      "1": "holnap",
      "2": "holnapután",
      "future": {
        "one": "{0} nap múlva",
        "other": "{0} nap múlva"
      },
      "past": {
        "one": "{0} napja",
        "other": "{0} napja"
      }
    },
    "day-short": {
      "-1": "tegnap",
      "-2": "tegnapelőtt",
      "0": "ma",
      "1": "holnap",
      "2": "holnapután",
      "future": {
        "one": "{0} nap múlva",
        "other": "{0} nap múlva"
      },
      "past": {
        "one": "{0} napja",
        "other": "{0} napja"
      }
    },
    "hour": {
      "0": "ebben az órában",
      "future": {
        "one": "{0} óra múlva",
        "other": "{0} óra múlva"
      },
      "past": {
        "one": "{0} órával ezelőtt",
        "other": "{0} órával ezelőtt"
      }
    },
    "hour-narrow": {
      "0": "ebben az órában",
      "future": {
        "one": "{0} óra múlva",
        "other": "{0} óra múlva"
      },
      "past": {
        "one": "{0} órával ezelőtt",
        "other": "{0} órával ezelőtt"
      }
    },
    "hour-short": {
      "0": "ebben az órában",
      "future": {
        "one": "{0} óra múlva",
        "other": "{0} óra múlva"
      },
      "past": {
        "one": "{0} órával ezelőtt",
        "other": "{0} órával ezelőtt"
      }
    },
    "minute": {
      "0": "ebben a percben",
      "future": {
        "one": "{0} perc múlva",
        "other": "{0} perc múlva"
      },
      "past": {
        "one": "{0} perccel ezelőtt",
        "other": "{0} perccel ezelőtt"
      }
    },
    "minute-narrow": {
      "0": "ebben a percben",
      "future": {
        "one": "{0} perc múlva",
        "other": "{0} perc múlva"
      },
      "past": {
        "one": "{0} perccel ezelőtt",
        "other": "{0} perccel ezelőtt"
      }
    },
    "minute-short": {
      "0": "ebben a percben",
      "future": {
        "one": "{0} perc múlva",
        "other": "{0} perc múlva"
      },
      "past": {
        "one": "{0} perccel ezelőtt",
        "other": "{0} perccel ezelőtt"
      }
    },
    "month": {
      "-1": "előző hónap",
      "0": "ez a hónap",
      "1": "következő hónap",
      "future": {
        "one": "{0} hónap múlva",
        "other": "{0} hónap múlva"
      },
      "past": {
        "one": "{0} hónappal ezelőtt",
        "other": "{0} hónappal ezelőtt"
      }
    },
    "month-narrow": {
      "-1": "előző hónap",
      "0": "ez a hónap",
      "1": "következő hónap",
      "future": {
        "one": "{0} hónap múlva",
        "other": "{0} hónap múlva"
      },
      "past": {
        "one": "{0} hónappal ezelőtt",
        "other": "{0} hónappal ezelőtt"
      }
    },
    "month-short": {
      "-1": "előző hónap",
      "0": "ez a hónap",
      "1": "következő hónap",
      "future": {
        "one": "{0} hónap múlva",
        "other": "{0} hónap múlva"
      },
      "past": {
        "one": "{0} hónappal ezelőtt",
        "other": "{0} hónappal ezelőtt"
      }
    },
    "nu": [
      "latn"
    ],
    "quarter": {
      "-1": "előző negyedév",
      "0": "ez a negyedév",
      "1": "következő negyedév",
      "future": {
        "one": "{0} negyedév múlva",
        "other": "{0} negyedév múlva"
      },
      "past": {
        "one": "{0} negyedévvel ezelőtt",
        "other": "{0} negyedévvel ezelőtt"
      }
    },
    "quarter-narrow": {
      "-1": "előző negyedév",
      "0": "ez a negyedév",
      "1": "következő negyedév",
      "future": {
        "one": "{0} n.év múlva",
        "other": "{0} n.év múlva"
      },
      "past": {
        "one": "{0} negyedévvel ezelőtt",
        "other": "{0} negyedévvel ezelőtt"
      }
    },
    "quarter-short": {
      "-1": "előző negyedév",
      "0": "ez a negyedév",
      "1": "következő negyedév",
      "future": {
        "one": "{0} negyedév múlva",
        "other": "{0} negyedév múlva"
      },
      "past": {
        "one": "{0} negyedévvel ezelőtt",
        "other": "{0} negyedévvel ezelőtt"
      }
    },
    "second": {
      "0": "most",
      "future": {
        "one": "{0} másodperc múlva",
        "other": "{0} másodperc múlva"
      },
      "past": {
        "one": "{0} másodperccel ezelőtt",
        "other": "{0} másodperccel ezelőtt"
      }
    },
    "second-narrow": {
      "0": "most",
      "future": {
        "one": "{0} másodperc múlva",
        "other": "{0} másodperc múlva"
      },
      "past": {
        "one": "{0} másodperccel ezelőtt",
        "other": "{0} másodperccel ezelőtt"
      }
    },
    "second-short": {
      "0": "most",
      "future": {
        "one": "{0} másodperc múlva",
        "other": "{0} másodperc múlva"
      },
      "past": {
        "one": "{0} másodperccel ezelőtt",
        "other": "{0} másodperccel ezelőtt"
      }
    },
    "week": {
      "-1": "előző hét",
      "0": "ez a hét",
      "1": "következő hét",
      "future": {
        "one": "{0} hét múlva",
        "other": "{0} hét múlva"
      },
      "past": {
        "one": "{0} héttel ezelőtt",
        "other": "{0} héttel ezelőtt"
      }
    },
    "week-narrow": {
      "-1": "előző hét",
      "0": "ez a hét",
      "1": "következő hét",
      "future": {
        "one": "{0} hét múlva",
        "other": "{0} hét múlva"
      },
      "past": {
        "one": "{0} héttel ezelőtt",
        "other": "{0} héttel ezelőtt"
      }
    },
    "week-short": {
      "-1": "előző hét",
      "0": "ez a hét",
      "1": "következő hét",
      "future": {
        "one": "{0} hét múlva",
        "other": "{0} hét múlva"
      },
      "past": {
        "one": "{0} héttel ezelőtt",
        "other": "{0} héttel ezelőtt"
      }
    },
    "year": {
      "-1": "előző év",
      "0": "ez az év",
      "1": "következő év",
      "future": {
        "one": "{0} év múlva",
        "other": "{0} év múlva"
      },
      "past": {
        "one": "{0} évvel ezelőtt",
        "other": "{0} évvel ezelőtt"
      }
    },
    "year-narrow": {
      "-1": "előző év",
      "0": "ez az év",
      "1": "következő év",
      "future": {
        "one": "{0} év múlva",
        "other": "{0} év múlva"
      },
      "past": {
        "one": "{0} évvel ezelőtt",
        "other": "{0} évvel ezelőtt"
      }
    },
    "year-short": {
      "-1": "előző év",
      "0": "ez az év",
      "1": "következő év",
      "future": {
        "one": "{0} év múlva",
        "other": "{0} év múlva"
      },
      "past": {
        "one": "{0} évvel ezelőtt",
        "other": "{0} évvel ezelőtt"
      }
    }
  },
  "locale": "hu"
})
}
